/**
 * Route for `soc-2-iso-27001-attested`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { Soc2Iso27001AttestedPage } from "../features/soc-2-iso-27001-attested/Soc2Iso27001AttestedPage";

export const soc2Iso27001AttestedRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/soc-2-iso-27001-attested",
	component: Soc2Iso27001AttestedPage,
});

export default soc2Iso27001AttestedRoute;
